import { status } from 'src/colors';
import { BookingPresence } from '../../types/booking-presence';

export const bookingPresenceColors: Record<BookingPresence, string> = {
  PRESENT: status.success,
  ABSENT: status.error,
};
